import "./ServicesSection.css";
import SectionTitle from "../common/SectionTitle";

const ServicesSection = () => {
  const services = [
    {
      number: "01",
      title: "Rekonstrukce",
      description:
        "Provádíme rekonstrukce bytů, domů a objektů od dílčích úprav po kompletní přestavby včetně technologií.",
    },
    {
      number: "02",
      title: "Rodinné domy",
      description:
        "Stavíme rodinné domy od základů. Zajišťujeme všechny stavební práce včetně koordinace.",
    },
    {
      number: "03",
      title: "Bytové domy",
      description:
        "Realizujeme výstavbu bytových domů a objektů různých velikostí.",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-wrapper">
        <SectionTitle title="Služby" />
        <h2 className="services-subtitle">Realizace staveb na klíč</h2>
        <p className="services-description">
          Vedeme stavbu od přípravy a rozpočtu přes hrubou stavbu až po
          dokončovací práce a předání.
        </p>

        <div className="services-cards">
          {services.map((service) => (
            <div key={service.title} className="service-card">
              <div className="card-top">
                <span className="card-number">{service.number}</span>
                <span className="card-marker" />
              </div>
              <h3 className="card-title">{service.title}</h3>
              <p className="card-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;